import React from 'react'
import classNames from 'classnames'
import './Button.css'

const ARROW_RIGHT = `
  <svg xmlns="http://www.w3.org/2000/svg" width="12" height="20">
    <path fill="#FFF" fill-rule="evenodd" d="M2.803 20L0 16.94 6.355 10 0 3.06 2.803 0 12 10"/>
  </svg>
`

const ARROW_LEFT  = `
  <svg xmlns="http://www.w3.org/2000/svg" width="13" height="20">
    <path fill="#6F6F6F" fill-rule="evenodd" d="M9.425 0l2.872 3.011-6.512 6.826 6.512 6.827-2.872 3.011L0 9.837z"/>
  </svg>
`

const PLUS = `
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24">
    <g fill="#417505" fill-rule="evenodd">
      <path d="M12.561 11.396H17v1.057h-4.439V17h-1.212v-4.547H7v-1.057h4.349V7h1.212z"/>
      <path fill-rule="nonzero" d="M12 0C5.373 0 0 5.373 0 12s5.373 12 12 12 12-5.373 12-12C23.994 5.375 18.625.006 12 0zm0 22.514C6.193 22.514 1.486 17.807 1.486 12 1.486 6.193 6.193 1.486 12 1.486c5.807 0 10.514 4.707 10.514 10.514-.006 5.804-4.71 10.508-10.514 10.514z"/>
    </g>
  </svg>
`;

export const icons = {
  ARROW_RIGHT,
  ARROW_LEFT,
  PLUS,
}

const Button = ({
  saving,
  className = '',
  type='submit',
  size='medium',
  children,
  icon = ARROW_RIGHT,
  prependIcon=false,
  buttonType=false,
  onClick,
}) => {
  const cls = classNames('button', className, { button__loading: saving, [`button__${buttonType}`]: buttonType, [`button__size-${size}`]: size, 'button__prepend-icon': prependIcon })
  return (
    <button disabled={saving} className={cls} type={ type } onClick={onClick}>
      { prependIcon ? (
        <span className="button--content"><span className="button--icon" dangerouslySetInnerHTML={{ __html: icon }} /> {children}</span>
      ) : (
        <span className="button--content">{children} <span className="button--icon" dangerouslySetInnerHTML={{ __html: icon }} /></span>
      )
      }
    </button>
  )
}

export default Button



// WEBPACK FOOTER //
// ./src/components/Button/Button.js